import * as React from 'react';

import Apps32 from './Apps32';

export const apps32 = () => <Apps32 />;

export default {
    title: 'Icon/Logo/Apps32',
    component: Apps32,
    parameters: {
        notes: "`import Apps32 from 'box-ui-elements/es/icon/logo/Apps32';`",
    },
};
